'use client';

import { AlertCircle } from 'lucide-react';
import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './UnidadPendingBadge.module.css';

const TOOLTIP = 'Tu solicitud de cambio de unidad está en revisión; un administrador la aprobará o rechazará.';

// Badge naranjo (icono de exclamación) con tooltip propio. El tooltip se renderiza
// en un PORTAL a document.body con position: fixed para que NO lo recorte ningún
// ancestro con overflow:hidden (p. ej. las filas del modal de info personal).
export function UnidadPendingBadge() {
	const ref = useRef<HTMLSpanElement>(null);
	const [coords, setCoords] = useState<{ top: number; left: number } | null>(null);

	const show = () => {
		const el = ref.current;
		if (!el) return;
		const r = el.getBoundingClientRect();
		setCoords({ top: r.top, left: r.left + r.width / 2 });
	};
	const hide = () => setCoords(null);

	return (
		<span
			ref={ref}
			className={styles.badge}
			tabIndex={0}
			role="img"
			aria-label={TOOLTIP}
			onMouseEnter={show}
			onMouseLeave={hide}
			onFocus={show}
			onBlur={hide}
		>
			<AlertCircle size={12} aria-hidden="true" />
			{coords &&
				typeof document !== 'undefined' &&
				createPortal(
					<span
						className={styles.tooltip}
						role="tooltip"
						style={{ top: coords.top, left: coords.left }}
					>
						{TOOLTIP}
					</span>,
					document.body,
				)}
		</span>
	);
}
